import { Variation } from '@/@core/services/app.service'
import { TableColumnsType } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Stack,
  Typography,
  Box,
  Chip,
  IconButton,
  Badge,
  Slide
} from '@mui/material'

import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { useContext } from 'react'
import { AbilityContext } from '@/layouts/components/acl/Can'
import { styled } from '@mui/material/styles'
import CommentOutline from 'mdi-material-ui/CommentOutline'
import { ExternalLinks } from '@/@core/services/api'
import { Circle, CircleHalfFull, MenuDown } from 'mdi-material-ui'
import {
  addCommas,
  chromosomeRegion,
  formatVariantInheritance,
  isJson,
  isWindow,
  renameChildTypes,
  unique
} from '@/@core/utils/utils'
import { useRouter } from 'next/router'
import { Rating } from '@mui/material'
import { strRang } from '../../VariationTables'

interface Props {
  setCurrent: any
  setOpen: any
  setHistoryOpen: any
  setCommentsOpen: any
  setTranscript_list: any
  handleMenuClick: any
  getColumnSearchProps: any
  setFilterGeneOpen: any
  setMenuType: any
  setFilterGeneData: any
  getFilterGene: any
  setIndexOpen: any
  setGeneIndexOpen: any
  setGeneOpen: any
  setAcmgOpen: any
  setOMIMOpen: any
  setIgvOpen: any
  setIgvLocus: any
  setCnvScipOpen: any
  setCnvAllOpen: any
  VariationGeneRef: any
  analysisInfo: any
  query: any
}
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // [`& .${tooltipClasses.tooltip}`]: {
  //   backgroundColor: 'rgba(97, 97, 97)',
  //   color: 'rgb(255, 255, 255)',
  //   maxWidth: 220,
  //   fontSize: theme.typography.pxToRem(12),
  //   border: '1px solid #dadde9'
  // }
}))

const TypographyA = styled(Typography)(() => ({
  fontSize: '0.8rem',
  color: 'inherit'
}))

const Badges = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: '-10px',
    backgroundColor: 'rgb(110,200,229)'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    maxHeight: 400,
    overflow: 'auto'
  }
})
const chromosome = [
  {
    text: 'chr1',
    value: '1'
  },
  {
    text: 'chr2',
    value: '2'
  },
  {
    text: 'chr3',
    value: '3'
  },
  {
    text: 'chr4',
    value: '4'
  },
  {
    text: 'chr5',
    value: '5'
  },
  {
    text: 'chr6',
    value: '6'
  },
  {
    text: 'chr7',
    value: '7'
  },
  {
    text: 'chr8',
    value: '8'
  },
  {
    text: 'chr9',
    value: '9'
  },
  {
    text: 'chr10',
    value: '10'
  },
  {
    text: 'chr11',
    value: '11'
  },
  {
    text: 'chr12',
    value: '12'
  },
  {
    text: 'chr13',
    value: '13'
  },
  {
    text: 'chr14',
    value: '14'
  },
  {
    text: 'chr15',
    value: '15'
  },
  {
    text: 'chr16',
    value: '16'
  },
  {
    text: 'chr17',
    value: '17'
  },
  {
    text: 'chr18',
    value: '18'
  },
  {
    text: 'chr19',
    value: '19'
  },
  {
    text: 'chr20',
    value: '20'
  },
  {
    text: 'chr21',
    value: '21'
  },
  {
    text: 'chr22',
    value: '22'
  },
  {
    text: 'chrX',
    value: 'X'
  },
  {
    text: 'chrY',
    value: 'Y'
  },
  {
    text: 'chrMT',
    value: 'MT'
  }
]

const color = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgba(229,38,35,0.8)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely pathogenic',
    color: 'rgba(221,109,32,0.8)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(46, 125, 50,0.8)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240,0.4)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200,0.8)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(109,56,149,0.8)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(237, 108, 2,0.8)'
  }
]

const GLScolor = [
  {
    key: 'pathogenic',
    value: 'pathogenic',
    color: 'rgb(218,150,148)'
  },
  {
    key: 'likely pathogenic',
    value: 'likely benign',
    color: 'rgb(245,182,193)'
  },
  {
    key: 'drug response',
    value: 'drug response',
    color: 'rgb(186,204,147)'
  },
  {
    key: 'uncertain significance',
    value: 'uncertain significance',
    color: 'rgb(240,239,240)'
  },
  {
    key: 'likely benign',
    value: 'likely benign',
    color: 'rgb(107,148,200)'
  },
  {
    key: 'benign',
    value: 'benign',
    color: 'rgb(64,113,190)'
  },
  {
    key: 'loss of function',
    value: 'loss of function',
    color: 'rgb(246,209,139)'
  }
]

export const judgeType = (str: string, arr: any[]) => {
  if (str.includes('child') && !str.includes('//')) {
    return 'C'
  } else if (str.includes('child') && str.includes('//')) {
    return `C${str.split('//')[1]}`
  } else if (str.includes('mother')) {
    return 'M'
  } else if (str.includes('father')) {
    return 'F'
  } else {
    return 'O'
  }
}

const columns2STR = React.forwardRef((props: Props, ref) => {
  const { t, i18n } = useTranslation()
  const ability = useContext(AbilityContext)

  const router = useRouter()

  const { id, ids, group } = router.query

  const type = router.asPath.includes('/samples') ? 'sample' : 'analyze'

  const column: TableColumnsType<Variation> = React.useMemo(() => {
    return [
      {
        dataIndex: 'gene',
        key: 'gene',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            {/* <Filters keys="gene" /> */}

            <Stack maxWidth={'100%'}>
              <span
                style={{
                  lineHeight: 'normal',
                  textAlign: 'left'
                }}
              >
                {t('Gene')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack
              maxWidth={'150px'}
              width={'100%'}
              direction="column"
              alignItems="start"
            >
              <TypographyA
                sx={{
                  color: '#23527c',
                  fontWeight: '700'
                }}
              >
                {row.gene}
              </TypographyA>
            </Stack>
          )
        },
        ...props.getColumnSearchProps('gene')
      },
      {
        dataIndex: 'chrom',
        key: 'chrom',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('Chrom')}
              </span>

              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                Start
              </span>

              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                End
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack
              maxWidth={'100px'}
              width={'100%'}
              direction="column"
              alignItems="start"
              sx={{
                cursor: 'pointer',
                color: '#23527c'
              }}
              onClick={() => {
                //
                props.setIgvOpen(true)

                props.setCurrent(row)

                props.setIgvLocus(`${row.chrom}:${row.start}-${row.end}`)
              }}
            >
              <TypographyA>{`${row.chrom}`}</TypographyA>

              <TypographyA>{`${row.start}`}</TypographyA>

              <TypographyA>{`${row.end}`}</TypographyA>
            </Stack>
          )
        }
      },
      {
        dataIndex: 'RU',
        key: 'RU',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('RU')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack
              maxWidth={'100px'}
              width={'100%'}
              direction="column"
              alignItems="start"
            >
              <TypographyA>{row.RU}</TypographyA>
            </Stack>
          )
        }
      },
      {
        dataIndex: 'GangSTR_repcn',
        key: 'GangSTR_repcn',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('GangSTR_repcn')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack maxWidth={'100%'}>
              <Stack maxWidth={'100%'} direction="column" spacing={1}>
                <TypographyA
                  sx={{
                    fontSize: '0.8rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pr: '10px'
                  }}
                >
                  <span>{row.GangSTR_repcn}</span>
                </TypographyA>
              </Stack>
            </Stack>
          )
        }
      },
      {
        dataIndex: 'EH_repcn',
        key: 'EH_repcn',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('EH_repcn')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack
              maxWidth={'100px'}
              width={'100%'}
              direction="column"
              alignItems="start"
            >
              <TypographyA>{row.EH_repcn}</TypographyA>
            </Stack>
          )
        }
      },
      {
        dataIndex: 'EH_ref',
        key: 'EH_ref',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: true,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            <Stack maxWidth={'100%'}>
              <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                {t('EH Ref')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          const temp = strRang.find((item) => item.gene == row.gene)

          return (
            <Stack
              maxWidth={'100px'}
              width={'100%'}
              direction="column"
              alignItems="start"
            >
              <TypographyA>{temp ? `n < ${temp.max}` : '-'}</TypographyA>
            </Stack>
          )
        }
      },
      {
        dataIndex: 'rangResult',
        key: 'rangResult',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack maxWidth={'100%'} justifyContent="start" direction={'row'}>
            {/* <Filters keys="gene" /> */}

            <Stack maxWidth={'100%'}>
              <span
                style={{
                  lineHeight: 'normal',
                  textAlign: 'left'
                }}
              >
                {t('Result')}
              </span>
            </Stack>
          </Stack>
        ),
        render: (value, row: any) => {
          return (
            <Stack
              maxWidth={'150px'}
              width={'100%'}
              direction="column"
              alignItems="start"
            >
              <TypographyA
                sx={{
                  color:
                    row.STR_Result && row.STR_Result === t('risky')
                      ? 'red'
                      : '#23527c',
                  fontWeight: '700'
                }}
              >
                {row.STR_Result}
              </TypographyA>
            </Stack>
          )
        },
        filters: [
          {
            value: 'risky',
            text: t('risky')
          },
          {
            value: 'risk-free',
            text: t('risk-free')
          },
          {
            value: '-',
            text: '-'
          }
        ],
        filterMultiple: false
      },
      {
        dataIndex: 'inheritance',
        key: 'inheritance',
        align: 'center',
        width: 80,
        ellipsis: true,
        sorter: false,
        title: () => (
          <Stack width={'100%'} direction={'row'} justifyContent="center">
            <Stack maxWidth={'100%'} justifyContent="center">
              {props.query && props.query.key && props.query.key === '5' ? (
                <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                  {t('Disease Information')}
                </span>
              ) : (
                <React.Fragment>
                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('OMIM')}
                  </span>

                  <span style={{ lineHeight: 'normal', textAlign: 'left' }}>
                    {t('Inheritance')}
                  </span>
                </React.Fragment>
              )}
            </Stack>
          </Stack>
        ),
        render: (value, rows: any) => {
          const row = {
            original: rows
          }

          if (props.query && props.query.key && props.query.key === '5') {
            return (
              <Stack maxWidth={'100%'} spacing={1}>
                {row.original.MitoMap && row.original.MitoMap.disease_ch ? (
                  <CustomWidthTooltip
                    title={
                      <Box>
                        <Typography color={'white'}>
                          {row.original.MitoMap.disease_ch}
                        </Typography>

                        <Typography color={'white'}>
                          {row.original.MitoMap.info}
                        </Typography>
                      </Box>
                    }
                    placement={'top-start'}
                    TransitionComponent={Slide}
                  >
                    <Box>
                      <TypographyA
                        sx={{
                          width: '100%',
                          maxWidth: 200,
                          lineHeight: '24px',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          cursor: 'pointer',
                          mb: '4px'
                        }}
                        key={`${row.original.MitoMap.disease_ch}`}
                      >
                        {row.original.MitoMap.disease_ch}
                      </TypographyA>

                      <TypographyA
                        sx={{
                          width: '100%',
                          maxWidth: 200,
                          lineHeight: '24px',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          cursor: 'pointer',
                          mb: '4px'
                        }}
                        key={`${row.original.MitoMap.info}`}
                      >
                        {row.original.MitoMap.info}
                      </TypographyA>
                    </Box>
                  </CustomWidthTooltip>
                ) : (
                  <TypographyA>.</TypographyA>
                )}
              </Stack>
            )
          } else if (
            i18n &&
            i18n.language === 'zh' &&
            row.original.OMIM?.geneDiseaseTranslated &&
            row.original.OMIM?.geneDiseaseTranslated.data
          ) {
            let OMIMValue = row.original.OMIM?.geneDiseaseTranslated?.data

            OMIMValue = unique(OMIMValue, 'disease')

            let bgcolor = color.find(
              (i) => i.key === row.original.CLINSIG_final?.toLowerCase()
            )
              ? (color.find(
                  (i) => i.key === row.original.CLINSIG_final?.toLowerCase()
                )?.color as any)
              : 'rgba(0, 0, 0)'

            // loss_of_function等于1 并且CLINSIG_final不等于P/LP
            if (row.original.CLINSIG_final?.toLowerCase() === 'pathogenic') {
              //
            } else if (
              row.original.CLINSIG_final?.toLowerCase() === 'likely pathogenic'
            ) {
              //
            } else if (row.original.loss_of_function === 1) bgcolor = '#f5d18c'

            return (
              <Stack maxWidth={'100%'} spacing={1}>
                {OMIMValue && OMIMValue.length ? (
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        {OMIMValue.map((item: any, index: any) => (
                          <TypographyA
                            sx={{
                              fontSize: '0.85rem',
                              lineHeight: '1rem',
                              maxWidth: isWindow()
                                ? '400px !important'
                                : '200px !important'
                            }}
                            key={`${item.disease}_${index}`}
                          >
                            {`(${
                              item.genetic_mode ? item.genetic_mode : '.'
                            })-${
                              i18n && i18n.language === 'zh' ? item.disease : ''
                            }`}
                          </TypographyA>
                        ))}
                      </React.Fragment>
                    }
                    placement={'top-start'}
                    TransitionComponent={Slide}
                    sx={{
                      '& .MuiTooltip-tooltip': {
                        maxWidth: isWindow() ? '400px' : '200px'
                      }
                    }}

                    // enterDelay={1000}
                    // onMouseEnter={async (e) => {
                    //   const sourceLanguage = 'en',
                    //     targetLanguage = 'zh'
                    //   const params: TranslateDto = {
                    //     sourceLanguage,
                    //     targetLanguage,
                    //     sourceText: OMIMValue
                    //   }
                    //   Translate.mutateAsync(params)
                    // }}
                  >
                    <Box>
                      {OMIMValue.slice(0, 2).map((items: any, index: any) => {
                        return (
                          <TypographyA
                            sx={{
                              width: '100%',
                              maxWidth: 200,
                              lineHeight: '24px',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              cursor: 'pointer',
                              color:
                                bgcolor === 'rgb(109,56,149,0.8)' ||
                                bgcolor === 'rgb(107,148,200,0.8)' ||
                                bgcolor === 'rgba(229,38,35,0.8)'
                                  ? 'white'
                                  : '#23527c',
                              mb: '4px'
                            }}
                            onClick={() => {
                              props.setCurrent(row.original)

                              props.setOMIMOpen(true)
                            }}
                            key={`${items.disease}_${index}`}
                          >
                            <Chip
                              label={`${
                                items.genetic_mode ? items.genetic_mode : '.'
                              }`}
                              size="small"
                              sx={{
                                height: 18,
                                fontSize: '0.75rem',
                                fontWeight: '700'
                              }}
                            />

                            <span
                              style={{
                                lineHeight: '24px'
                              }}
                            >{`${
                              i18n && i18n.language === 'zh'
                                ? items.disease + '-'
                                : ''
                            }${items.disease}`}</span>
                          </TypographyA>
                        )
                      })}

                      {/* {OMIMValue.length > 3 ? '...' : ''} */}
                    </Box>
                  </HtmlTooltip>
                ) : (
                  <TypographyA>.</TypographyA>
                )}
              </Stack>
            )
          } else {
            let OMIMValue =
              row.original.OMIM?.omimData.map((item: any) => {
                const inheritances: string[] = []

                if (
                  item &&
                  item.clinicalSynopsis &&
                  item.clinicalSynopsis.INHERITANCE &&
                  Array.isArray(item.clinicalSynopsis.INHERITANCE)
                ) {
                  item.clinicalSynopsis.INHERITANCE.forEach((str: string) =>
                    inheritances.push(str.toLowerCase())
                  )
                }
                const inheritance = formatVariantInheritance(
                  Array.from([...new Set(inheritances)]).join(',')
                )

                return {
                  ...item,
                  inheritance
                }
              }) ?? []

            OMIMValue = unique(OMIMValue, 'phenoName')

            let bgcolor = color.find(
              (i) => i.key === row.original.CLINSIG_final?.toLowerCase()
            )
              ? (color.find(
                  (i) => i.key === row.original.CLINSIG_final?.toLowerCase()
                )?.color as any)
              : 'rgba(0, 0, 0)'

            // loss_of_function等于1 并且CLINSIG_final不等于P/LP
            if (row.original.CLINSIG_final?.toLowerCase() === 'pathogenic') {
              //
            } else if (
              row.original.CLINSIG_final?.toLowerCase() === 'likely pathogenic'
            ) {
              //
            } else if (row.original.loss_of_function === 1) bgcolor = '#f5d18c'

            return (
              <Stack maxWidth={'100%'} spacing={1}>
                {OMIMValue && OMIMValue.length ? (
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        {OMIMValue.map((item: any, index: any) => (
                          <TypographyA
                            sx={{
                              fontSize: '0.85rem',
                              lineHeight: '1rem',
                              maxWidth: isWindow()
                                ? '400px !important'
                                : '200px !important'
                            }}
                            key={`${item.phenoName}_${index}`}
                          >
                            {`(${item.inheritance ? item.inheritance : '.'})-${
                              i18n && i18n.language === 'zh'
                                ? item.pheno_name_cn + '-'
                                : ''
                            }${item.phenoName}`}
                          </TypographyA>
                        ))}
                      </React.Fragment>
                    }
                    placement={'top-start'}
                    TransitionComponent={Slide}
                    sx={{
                      '& .MuiTooltip-tooltip': {
                        maxWidth: isWindow() ? '400px' : '200px'
                      }
                    }}

                    // enterDelay={1000}
                    // onMouseEnter={async (e) => {
                    //   const sourceLanguage = 'en',
                    //     targetLanguage = 'zh'
                    //   const params: TranslateDto = {
                    //     sourceLanguage,
                    //     targetLanguage,
                    //     sourceText: OMIMValue
                    //   }
                    //   Translate.mutateAsync(params)
                    // }}
                  >
                    <Box>
                      {OMIMValue.slice(0, 2).map((items: any, index: any) => {
                        return (
                          <TypographyA
                            sx={{
                              width: '100%',
                              maxWidth: 200,
                              lineHeight: '24px',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              cursor: 'pointer',
                              color:
                                bgcolor === 'rgb(109,56,149,0.8)' ||
                                bgcolor === 'rgb(107,148,200,0.8)' ||
                                bgcolor === 'rgba(229,38,35,0.8)'
                                  ? 'white'
                                  : '#23527c',
                              mb: '4px'
                            }}
                            onClick={() => {
                              props.setCurrent(row.original)

                              props.setOMIMOpen(true)
                            }}
                            key={`${items.phenoMim}_${index}`}
                          >
                            <Chip
                              label={`${
                                items.inheritance ? items.inheritance : '.'
                              }`}
                              size="small"
                              sx={{
                                height: 18,
                                fontSize: '0.75rem',
                                fontWeight: '700'
                              }}
                            />

                            <span
                              style={{
                                lineHeight: '24px'
                              }}
                            >{`${
                              i18n && i18n.language === 'zh'
                                ? items.pheno_name_cn + '-'
                                : ''
                            }${items.phenoName}`}</span>
                          </TypographyA>
                        )
                      })}

                      {/* {OMIMValue.length > 3 ? '...' : ''} */}
                    </Box>
                  </HtmlTooltip>
                ) : (
                  <TypographyA>.</TypographyA>
                )}
              </Stack>
            )
          }
        }
      }
    ]
  }, [props])

  React.useImperativeHandle(ref, () => ({
    column
  }))

  return <></>
})

export default columns2STR
